import * as React from "react";

import { SimpleComponent } from "./SimpleComponent"
import { LinkButton } from "./LinkButton";
import { navigateToRoute } from "./navigation";

export interface IRouteButtonProps {
    className?: string;
    to: string;
}

export class RouteButton extends SimpleComponent<IRouteButtonProps> {
    constructor(props: IRouteButtonProps) {
        super(props);
    }

    render() {
        return <LinkButton
                   className={this.props.className}
                   to={this.props.to}
                   onClick={() => navigateToRoute(this.props.to) }>{this.props.children}</LinkButton>;
    }
}


// WEBPACK FOOTER //
// ./Scripts/React/Component/RouteButton.tsx